import React from 'react';
import { FormikHelpers, FormikProps } from 'formik';
import {
    Modal,
    ModalHeader,
    ModalActions,
    ActionList,
    ButtonPrimary,
    ButtonOutlinePrimary,
    Form,
    InputText,
    InputPhone,
    InputSelect,
    Icon
} from '../../components-v2/shared';
import { AddEntryFormValidationSchema } from './AddEntryModal.validations';

export interface AddEntryFormData {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
    is_agree_sms_notification: string;
}

interface AddEntryModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (values: AddEntryFormData, formikHelpers: FormikHelpers<AddEntryFormData>) => void;
    isSubmitting?: boolean;
}

const smsNotificationOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
];

export const AddEntryModal: React.FC<AddEntryModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    isSubmitting = false
}) => {
    const initialValues: AddEntryFormData = {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        is_agree_sms_notification: 'No',
    };

    const handleSubmit = (values: AddEntryFormData, formikHelpers: FormikHelpers<AddEntryFormData>) => {
        onSubmit(values, formikHelpers);
    };

    return (
        <Modal isOpen={isOpen} closeButton={false}>
            <ModalHeader
                title={
                    <>
                        <Icon name="plus" />
                        Add New Entry
                    </>
                }
            />
            <Form
                initialValues={initialValues}
                validationSchema={AddEntryFormValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {(formikProps: FormikProps<AddEntryFormData>) => (
                    <>
                        <div style={{ padding: '20px 0' }}>
                            <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <InputText
                                        name="first_name"
                                        label="First Name*"
                                        formikProps={formikProps}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <InputText
                                        name="last_name"
                                        label="Last Name*"
                                        formikProps={formikProps}
                                    />
                                </div>
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <InputText
                                    name="email"
                                    label="Email Address*"
                                    formikProps={formikProps}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <InputPhone
                                        name="phone_number"
                                        label="Phone Number*"
                                        formikProps={formikProps}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <InputSelect
                                        name="is_agree_sms_notification"
                                        label="SMS Notifications*"
                                        options={smsNotificationOptions}
                                        optionLabelKey="label"
                                        optionValueKey="value"
                                        formikProps={formikProps}
                                    />
                                </div>
                            </div>
                        </div>
                        <ModalActions>
                            <ActionList position="end">
                                <ButtonOutlinePrimary
                                    type="button"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </ButtonOutlinePrimary>
                                <ButtonPrimary
                                    type="submit"
                                    disabled={isSubmitting || !formikProps.isValid}
                                >
                                    {isSubmitting ? 'Adding...' : 'Add Entry'}
                                </ButtonPrimary>
                            </ActionList>
                        </ModalActions>
                    </>
                )}
            </Form>
        </Modal>
    );
};
